module.exports = __webpack_public_path__ + "img/icon_play.6e5769af.svg";